<template>
  <v-form v-model="form_valido" lazy-validation ref="formulario">
    <z-dialogo
      ref="dialogo"
      largura="700px"
      titulo="Lote"
      dividers
      persistent
      @abrir="$refs.formulario.resetValidation()"
    >
      <template v-slot:conteudo>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="lote.descricao"
              ref="descricao"
              label="Descrição"
              placeholder=" "
            ></v-text-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:actions_right>
        <v-btn text @click="fechar" :disabled="salvando">Cancelar</v-btn>
        <v-btn
          color="primary"
          ref="btnConfirmar"
          @click="confirmar"
          :loading="salvando"
          :disabled="!form_valido"
          >Confirmar</v-btn
        >
      </template>
    </z-dialogo>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import * as regras from "@/app/helpers/validacoes";

export default {
  name: "LotesForm",

  data() {
    return {
      excluindo: false,
      salvando: false,
      form_valido: true,
      regras: { ...regras },
    };
  },

  computed: {
    ...mapState(["loading"]),
    ...mapState("lotes", ["lote"]),
  },

  methods: {
    ...mapActions("lotes", [
      "listar",
      "excluir",
      "abrir",
      "atualizar",
      "salvar",
    ]),

    abrir() {
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.formulario.resetValidation();
      this.$refs.dialogo.fechar();
    },

    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.lote.id) {
          await this.atualizar(this.lote);
          this.$eventbus.notificar("Lote atualizado.");
        } else {
          await this.salvar(this.lote);
          this.$eventbus.notificar("Lote cadastrado com sucesso.");
        }

        this.fechar();
      } catch (error) {
        this.$eventbus.erroSistema(
          "Não foi possível salvar esta lote. Verifique os dados preenchidos."
        );
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped></style>
